import ReactGA from "react-ga4";
// issuse https://github.com/codler/react-ga4#readme


export function initialize(params) {
    ReactGA.initialize([
        {
          trackingId: "G-74W24JPM9D",
        }
    ]);  
}

export function sendPageView(url, title) {
    ReactGA.send({ hitType: "pageview", page: url, title: title });
}

export function sendEvent(params) {
    ReactGA.event({
        category: "your category",
        action: "your action",
        label: "your label", // optional
        value: 0, // optional, must be a number
        nonInteraction: true, // optional, true/false
        transport: "xhr", // optional, beacon/xhr/image
    });
}


